import Vendor from '@/models/Vendor/Vendor';

export default class VendorFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.code = '';
		this.name = '';
		this.officeAddressMultiple = '';
		this.officePhoneNumber = '';
		this.contactPerson = '';
		this.contactPersonPhoneNumber = '';
		this.contactPersonEmail = '';
		this.vendorTypeId  = '';
		this.vendorTypeCode = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
		this.vendorTypeCode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			id : '0',
			code : '0',
			name : '0',
			officeAddressMultiple : '0',
			officePhoneNumber : '0',
			contactPerson : '0',
			contactPersonPhoneNumber : '0',
			contactPersonEmail : '0',
			vendorTypeId : '0',
			vendorTypeCode : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
			vendorTypeCode : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}